export default __webpack_public_path__ + "static/media/polk_g_standard.8d4b8922.png";